__webpack_require__.p = "/inventralabs/";